module.exports = __webpack_public_path__ + "static/media/Xingqiu.4569d28a.png";